import sendLog from '@/utils/analistic'
import MobileDetect from 'mobile-detect'
import router from '@/router'
import store from '@/store'
import { i18n } from '../i18n'

/*
 * fcm 상점만 nexon live iframe에서 쇼핑 연동.
 * 이 상황에서 UI분기를 위해 체크함
 */
const isInIframe = () => {
  let isFramed = false

  try {
    isFramed = window.top !== window.self
  } catch (e) {
    isFramed = true // 보안 정책에 의해 접근이 차단됨 = iframe 안
  }

  return (
    (getShopId() === 'fcmobile' ||
      getShopId() === 'fcmtest' ||
      getShopId() === 't900') &&
    isFramed
  )
}

const isFCM = () => {
  return (
    getShopId() === 'fcmobile' ||
    getShopId() === 'fcmtest' ||
    getShopId() === 't900'
  )
}

const getFCMGID = () => {
  const isDev = process.env.NODE_ENV === 'development'
  const isProd = process.env.NODE_ENV === 'production'

  if (isDev && isFCM()) {
    return 2536
  }

  if (isProd && getShopId() === 'fcmtest') {
    return 1868
  }

  if (isProd && getShopId() === 'fcmobile') {
    return 1867
  }

  if (isProd && getShopId() === 't900') {
    return 2538
  }

  return null
}

/**
 * 모바일 디바이스 여부를 판단한다.
 */
const isMobile = (() => {
  const md = new MobileDetect(navigator.userAgent)
  return !!md.mobile()
})()
/**
 * 모바일 디바이스 OS를 판단한다.
 */
const isMobileOS = (() => {
  const md = new MobileDetect(navigator.userAgent)
  return md.os()
})()
/**
 * class 이름이 포함된 부모 노드를 찾는다.
 * @param {documentElement} el - DOM
 * @param {String} cls - class명
 */
const findAncestor = (el, cls) => {
  while (el && !el.classList.contains(cls)) {
    el = el.parentElement
  }
  return el
}

/**
 * 로그인 상태여부를 반환 한다.
 */
const isLogin = () => {
  return window.inface.auth.isSignedIn()
}

/**
 * 로그아웃을 처리를 한다.
 */
const logout = () => {
  if (typeof window.inface !== 'undefined') {
    window.inface.auth.gotoSignOut({ redirect_uri: process.env.VUE_APP_HOST })
  }
}
/**
 * manifiest json 형태를 동적으로 생성한다.
 * @param {String} name - 상점 이름
 */
const createManifest = (name, shopId) => {
  const { origin } = location
  const short_name = name
  const path = origin + `/static/favicon/${shopId}`
  const start_url = origin + `/${shopId}`
  const scope = origin + `/${shopId}`
  const mobile_login_url = process.env.VUE_APP_LOGIN_URL
  return {
    short_name,
    name,
    start_url,
    scope,
    stay_in_app: [mobile_login_url],
    display: 'standalone',
    background_color: '#ffffff',
    theme_color: '#ffffff',
    orientation: 'portrait',
    icons: [
      {
        src: `${path}/icon-36x36.png`,
        sizes: '36x36',
        type: 'image/png',
        density: '0.75'
      },
      {
        src: `${path}/icon-48x48.png`,
        sizes: '48x48',
        type: 'image/png',
        density: '1.0'
      },
      {
        src: `${path}/icon-72x72.png`,
        sizes: '72x72',
        type: 'image/png',
        density: '1.5'
      },
      {
        src: `${path}/icon-96x96.png`,
        sizes: '96x96',
        type: 'image/png',
        density: '2.0'
      },
      {
        src: `${path}/icon-144x144.png`,
        sizes: '144x144',
        type: 'image/png',
        density: '3.0'
      },
      {
        src: `${path}/icon-192x192.png`,
        sizes: '192x192',
        type: 'image/png',
        density: '4.0'
      }
    ]
  }
}

/**
 * 로그인 페이지로 이동시킨다.
 */
const goToLoginPage = () => {
  if (typeof window.inface !== 'undefined') {
    console.log('isInIframe', isInIframe())
    console.log('window.$nxlive', window.$nxlive)
    console.log('window.$nxlive.gotoSignIn', window.$nxlive.gotoSignIn)
    console.log('window.$nxlive.close', window.$nxlive.close)
    if (isInIframe() && window.$nxlive && window.$nxlive.gotoSignIn) {
      window.$nxlive.gotoSignIn()
      return
    }
    window.inface.auth.gotoSignIn({ redirect_uri: window.location.href })
  }
}
/**
 * 인트로 페이지로 이동시킨다.
 */
const goToIntro = () => {
  location.href = `${location.origin}/intro.html`
}

/**
 * 로그인이 필요한 func인지 체크를 한다.
 * @param {Function} func - 호출할 콜백
 */
const loginCheckWrap = func => {
  if (isLogin()) {
    func()
  } else {
    store.dispatch('modal/openModalLogin', null, { root: true })
  }
}
/**
 * 리워드 상품인지 체크를 한다.
 * @param {Function} func - 호출할 콜백
 */
const rewardCheckWrap = (og, func) => {
  if (!og) {
    func()
  } else {
    store.dispatch('modal/openModalRewardCart', func, { root: true })
  }
}
/**
 * 제품 배열 기준으로 가격 오브젝트를 반환한다.
 * @param {Array} products - 제품 배열
 * @returns {Object}
 */
const calProductsPriceObejct = products =>
  products.reduce(
    (
      total,
      { price, displayPrice, purchaseCount, productType, currencyUnit }
    ) => {
      total.price += price * purchaseCount
      total.displayPrice += displayPrice * purchaseCount
      total.benefit += (displayPrice - price) * purchaseCount

      total.limitPrice[productType] =
        total.limitPrice[productType] || 0 + price * purchaseCount
      total.currencyUnit = currencyUnit || i18n.t('common.unit.unit_currency')
      return total
    },
    { price: 0, displayPrice: 0, benefit: 0, limitPrice: {}, currencyUnit: '' }
  )

/**
 * 현재 path 기준으로 A2S에 보낼 이름을 반환한다.
 * @returns {String}
 */
const pathToName = () => {
  const { name } = router.currentRoute
  switch (name) {
    case 'main':
      return 'Main'
    case 'category':
      return 'Category'

    case 'product':
      return 'Product'

    case 'cart':
      return 'Cart'

    case 'order':
      return 'Order'

    case 'orderComplete':
      return 'Success'

    case 'my':
      return 'My'

    case 'recent':
      return 'Recent'

    case 'coupon':
      return 'Coupon'

    case 'couponView':
      return 'Coupon'

    /* case 'purchase':

      case 'cancel':

      case 'cancelView':

      case 'cancelApply':

      case 'tagList': */

    case 'search-tag':
      return 'Search_Tag'
    case 'search-product':
      return 'Search_Product'
    case 'characters':
      return 'Character'

    default:
      return name
  }
}

/**
 * 로그인이 필요한 값인지 확인한다.
 * @param {String} str
 * @returns {Boolean}
 */
const requireLogin = str => !!str.match(/coupon|cart|order/gi)

/**
 * A2S 로그를 전송한다
 * @param {String} object
 * @param {Object} option
 * @param {String} type
 */
const beforeSendLog = (object = '', option = {}, type = 'click') => {
  // 로그인이 필요 없거나, 로그인이 필요한 페이지 인데 로그인을 한 경우만 로그를 보낸다.
  // coupon / cart/ order -> 로그인 필요 && isLogin == false =>  true * true => false ( 안보낸다 )
  // coupon / cart/ order -> 이 아니면 false && true or false = > false => true (보낸다)
  const shopId = store.getters['main/shopId']
  if (!(requireLogin(object) && !isLogin()) && shopId) {
    const obj = object ? `${pathToName()}_${object}` : obj,
      opt = { ...option, ShopID: store.getters['main/shopId'] }
    sendLog(obj, opt, type)
  }
}

/**
 * 현재 날짜 기준으로 새로운 날짜를 계산한다.
 * @param {Number} minus - 현재 날짜와 계산할 차이
 * @param {String} type - 일로 계산할 건지 달로 계산할 건지
 * @returns {String}
 */
const getYYYYMMDD = (minus, type) => {
  var d = new Date(),
    month,
    day,
    year
  if (minus) {
    if (type === 'day') {
      d.setDate(d.getDate() - minus)
    } else {
      d.setMonth(d.getMonth() - minus)
    }
  }

  month = d.getMonth() + 1
  day = d.getDate()
  year = d.getFullYear()

  if (month < 10) month = '0' + month
  if (day < 10) day = '0' + day

  return [year, month, day].join('-')
}
/**
 * Date를 YYYY MM DD 형태로 변환 한다.
 * @param {Date} date - date 객체
 */
const dateToYYYYMMDD = date => {
  const MM = date.getMonth() + 1,
    DD = date.getDate()
  return [
    date.getFullYear(),
    '-',
    (MM > 9 ? '' : '0') + MM,
    '-',
    (DD > 9 ? '' : '0') + DD
  ].join('')
}

/**
 * 상품 상태를 string 형태로 반환한다.
 * @param {Number} productStatus - 상품 상태
 * @returns {String}
 */
const convertProductStatusToKor = productStatus => {
  switch (productStatus) {
    case -1: // 서버에서 내려주지 않는 로직
      return i18n.t('status.product.exceed_quantity')
    case 1:
      return i18n.t('status.product.pre_sale_A11')
    case 3:
      return i18n.t('status.product.end_of_sale_A12')
    case 4:
      return i18n.t('status.product.sold_out_A13')
    default:
      return i18n.t('status.product.unavailable_for_purchase_A21')
  }
}

/**
 * 구매 타입을 string 형태로 반환한다.
 * @param {Number} paymentType - 구매 타입
 * @returns {String}
 */
const convertPaymentType = paymentType => {
  switch (paymentType) {
    case 1:
      return i18n.t('status.payment.kakaopay')
    case 2:
      return i18n.t('status.payment.tosspay')
    case 3:
      return i18n.t('status.payment.payco')
    case 4:
      return i18n.t('status.payment.cultural_voucher')
    case 5:
      return i18n.t('status.payment.credit_card')
  }
}
/**
 * 쿠폰 상태를 string 형태로 반환한다.
 * @param {Number} status - 상태값
 * @param {String} usedDate - 사용날짜
 * @returns {String}
 */
const convertCouponStatus = (status, usedDate) => {
  switch (status) {
    case 0:
      return i18n.t('status.coupon.none')
    case 1:
      return i18n.t('status.coupon.pre_issued')
    case 100:
    case 101:
      return i18n.t('status.coupon.issued')
    case 150:
      return !!usedDate === false
        ? i18n.t('status.coupon.available')
        : i18n.t('status.coupon.used')
    case 200:
      return i18n.t('status.coupon.withdrawn')
    case 201:
      return i18n.t('status.coupon.recalled')
    case 255:
      return i18n.t('status.coupon.failed')
  }
}

/**
 * 구매 상태를 string 형태로 반환한다.
 * @param {Number} status - 상태값
 * @returns {String}
 */
const convertPurchaseStatus = status => {
  switch (status) {
    case 100:
      return i18n.t('status.purchase.payment_completed')
    case 120:
      return i18n.t('status.purchase.preparing_for_shipping')
    case 121:
      return i18n.t('status.purchase.shipped')
    case 150:
      return i18n.t('status.purchase.purchase_confirmed')
    case 160:
      return i18n.t('status.purchase.exchange_received')
    case 161:
      return i18n.t('status.purchase.return_received')
    case 162:
      return i18n.t('status.purchase.return_completed')
    case 200:
      return i18n.t('status.purchase.withdrawn')
    case 201:
      return i18n.t('status.purchase.recalled')
    case 255:
      return i18n.t('status.purchase.failed')
  }
}
/**
 * 구매 상태를 string 형태로 반환한다.
 * 실물 상품 판매가 추가 되면서 청약 철회 -> 주문취소 형태로 변경 되서 따로 제작
 * @param {Number} status - 상태값
 * @returns {String}
 */
const convertDeliveryPurchaseStatus = status => {
  switch (status) {
    case 100:
      return i18n.t('status.delivery.payment_completed')
    case 120:
      return i18n.t('status.delivery.preparing_for_shipping')
    case 121:
      return i18n.t('status.delivery.shipped')
    case 150:
      return i18n.t('status.delivery.purchase_confirmed')
    case 160:
      return i18n.t('status.delivery.exchange_received')
    case 161:
      return i18n.t('status.delivery.return_received')
    case 162:
      return i18n.t('status.delivery.return_completed')
    case 200:
      return i18n.t('status.delivery.order_cancel_completed')
    case 201:
      return i18n.t('status.delivery.recalled')
    case 255:
      return i18n.t('status.delivery.failed')
  }
}
/**
 * 청약철회 상태를 string 형태로 반환한다.
 * @param {Number} status - 상태값
 * @returns {String}
 */
const convertCancelStatus = status => {
  switch (status) {
    case 0:
      return i18n.t('status.cancel.unknown')
    case 1:
      return i18n.t('status.cancel.requested')
    case 100:
      return i18n.t('status.cancel.payment_cancel_completed')
    case 101:
      return i18n.t('status.cancel.cash_refund_completed')
    case 200:
      return i18n.t('status.cancel.canceled')
    case 255:
      return i18n.t('status.cancel.failed')
  }
}
/**
 * 구매 갯수 제한을 확인한다.
 * @param {Number} newPurchaseCount - 구매를 원하는 갯수
 * @param {Object} product - 구매를 원하는 해당 객체
 * @param {Boolean} noModal - 모달 표시 여부
 * @returns {Boolean}
 */
const checkCountLimit = (newPurchaseCount, product, noModal) => {
  const isLimitByOne = product.maxQuantityOne > 0
  const isLimitByUser = product.maxQuantityUser > 0
  const remainQuantityUser = product.hasOwnProperty('remainQuantityUser')
    ? product.remainQuantityUser
    : product.maxQuantityUser
  const isSalesQuantity = product.enableSalesQuantity
  const remainQuantity = product.remainQuantity

  // 작은애가 먼저 걸려야한다.
  let whoIsFirst = null
  let limitCount = 0
  if (isLimitByOne && isLimitByUser) {
    if (product.maxQuantityOne > remainQuantityUser) {
      whoIsFirst = 'byUser'
      limitCount = remainQuantityUser
    } else {
      whoIsFirst = 'byOne'
      limitCount = product.maxQuantityOne
    }
  } else if (isLimitByOne) {
    limitCount = product.maxQuantityOne
  } else if (isLimitByUser) {
    limitCount = remainQuantityUser
  } else if (isSalesQuantity) {
    limitCount = remainQuantity
  }

  if (
    (isLimitByOne || isLimitByUser || isSalesQuantity) &&
    newPurchaseCount > limitCount
  ) {
    if (typeof noModal === 'undefined') {
      if (whoIsFirst !== null) {
        if (whoIsFirst === 'byOne') {
          store.dispatch(
            'modal/openModalOrderLimitByOne',
            product.maxQuantityOne
          )
        } else {
          store.dispatch('modal/openModalOrderLimitByUser', {
            count: product.maxQuantityUser,
            rest: remainQuantityUser
          })
        }
      } else if (isLimitByUser) {
        // 유저 한도 제한
        store.dispatch('modal/openModalOrderLimitByUser', {
          count: product.maxQuantityUser,
          rest: remainQuantityUser
        })
      } else if (isLimitByOne) {
        // 1회 한도 제한
        store.dispatch('modal/openModalOrderLimitByOne', product.maxQuantityOne)
      } else if (isSalesQuantity) {
        store.dispatch(
          'modal/openModalOrderLimitByRemainQuantity',
          product.remainQuantity
        )
      }
    }
    return false
  }
  return true
}

/**
 * iOS의 크롬 브라우저 여부를 판단한다.
 */
const isIOSChrome = () => {
  return /CriOS/i.test(navigator.userAgent)
}

function isLegacyIntro() {
  const currentURL = new URL(location.href)
  const firstPath = currentURL.pathname.split('/')[1]

  if (!firstPath || firstPath === 'intro.html') {
    // default path 는 kr intro 가 될 수 밖에 없음. 다른 국가를 판단할 수 있는 정보가 없기 때문
    return true
  }
  return false
}

function isLegacyURL() {
  const currentURL = new URL(location.href)
  const firstPath = currentURL.pathname.split('/')[1]
  // kr, jp가 없는 경우 레거시 url임. 따라서 kr로 모두 url history state 변경
  return firstPath !== 'kr' && firstPath !== 'jp'
}

function redirectToHit2IfJPIntro() {
  const currentURL = new URL(location.href)
  const firstPath = currentURL.pathname.split('/')[1]
  const secondPath = currentURL.pathname.split('/')[2]

  // shopping.nexon.com/jp
  // shopping.nexon.com/jp/intro.html
  // 위 두가지 경우에 hit2 shopId로 redirect

  if (firstPath === 'jp' && (!secondPath || secondPath === 'intro.html')) {
    location.href = `${location.origin}/jp/hittheworld`
  }
}

function getBaseInfo() {
  // url에 kr/jp 등이 새 path가 붙기 이전이 아닌 경우를 가정함
  // 이전의 레거시 URL의 경우엔 라우터에서 처리하도록 작업 되어있음
  const currentURL = new URL(location.href)
  const nationPath = currentURL.pathname.split('/')[1]
  const shopIdPath = currentURL.pathname.split('/')[2]

  let base = ''
  if (currentURL.pathname.indexOf('intro.html') === -1) {
    base = `${nationPath}/${shopIdPath}`
  }

  return { base, nationPath, shopIdPath }
}

function getShopId() {
  // url에 kr/jp 등 path가 붙은 경우를 가정함
  // 이전의 레거시 URL의 경우엔 라우터에서 처리하도록 작업 되어있음
  const currentURL = new URL(location.href)
  const shopIdPath = currentURL.pathname.split('/')[2]

  if (shopIdPath === 'intro.html') {
    return ''
  }

  return shopIdPath
}

export {
  isLogin,
  logout,
  findAncestor,
  createManifest,
  goToLoginPage,
  loginCheckWrap,
  rewardCheckWrap,
  calProductsPriceObejct,
  isMobile,
  isMobileOS,
  beforeSendLog,
  getYYYYMMDD,
  dateToYYYYMMDD,
  convertProductStatusToKor,
  convertPaymentType,
  convertPurchaseStatus,
  convertDeliveryPurchaseStatus,
  convertCouponStatus,
  convertCancelStatus,
  checkCountLimit,
  goToIntro,
  isIOSChrome,
  isLegacyIntro,
  isLegacyURL,
  getBaseInfo,
  getShopId,
  redirectToHit2IfJPIntro,
  isInIframe,
  getFCMGID,
  isFCM
}
